export const InboundStudiesList = "/inbound_manager/all_studies";
export const InboundSearchStudy = "/inbound_manager/search_studies";
export const UpdatePatientId = "/inbound_manager/update_patient_id";
export const DeleteStudy = "/inbound_manager/delete_study";
export const CheckStudy = "/inbound_manager/check_study";
export const GetAllStudies = "/inbound_manager/all_studies";